import React, { useState } from 'react';
import { useEffect } from 'react';
import { connect } from 'react-redux';
import UIFx from 'uifx';

import WanderlandHome from './WanderlandHome';
import WanderlandStage from './WanderlandStage';
import WanderlandStageBoss from './WanderlandStageBoss';
import WanderlandStageVideo from './WanderlandStageVideo';
import { useImagesContext } from '../../contexts/ImagesContext';

import selectStageFile from './sounds/select-stage.mp3';
import { Delay } from '../../utils/delay';

const selectStage = new UIFx(selectStageFile);

const PAGES = {
  HOME: 'HOME',
  STAGE: 'STAGE',
  STAGE_BOSS: 'STAGE_BOSS',
  STAGE_VIDEO: 'STAGE_VIDEO',
};

const Wanderland = ({ history, student, config }) => {
  const [wanderlandId, setWanderlandId] = useState(null);
  const [stage, setStage] = useState(null);
  const [wanderland, setWanderland] = useState(null);
  // const [stage, setStage] = useState({
  //   id: 7,
  //   number: 2,
  //   title: null,
  //   image: '/files/wanderland/c0533de6-8180-46a9-a9f5-eac4db27495a.png',
  //   imageTop: 501,
  //   imageLeft: 1200,
  //   walkTop: 500,
  //   walkLeft: 1000,
  //   stageType: 'boss',
  //   video: '',
  //   issueYardnapha: 2,
  //   bossRank: 'S',
  //   createdAt: '2024-11-07T07:47:54.000Z',
  //   updatedAt: '2024-11-10T04:00:41.000Z',
  //   wanderlandId: 1,
  //   isPass: false,
  //   canAccess: true,
  // });
  // const [wanderland, setWanderland] = useState({
  //   id: 1,
  //   title: '',
  //   bossBackground:
  //     '/files/wanderland/a0a29277-1118-4601-adb5-e9bcf2b57e8b.jpg',
  // });

  const [issueYardnapha, setIssueYardnapha] = useState(null);
  const [issuePoint, setIssuePoint] = useState(null);
  const { images } = useImagesContext();
  let page = PAGES.HOME;
  if (wanderlandId) {
    page = PAGES.STAGE;
  }
  if (stage && stage.stageType === 'boss') {
    page = PAGES.STAGE_BOSS;
  }
  if (stage && stage.stageType === 'video') {
    page = PAGES.STAGE_VIDEO;
  }

  const handleStageBack = () => {
    setStage(null);
  };

  const handleStageCompleted = (issueYardnapha, issuePoint) => {
    console.debug('handleStageCompleted', { issuePoint, issueYardnapha });
    if (issueYardnapha) {
      setIssueYardnapha(issueYardnapha);
    }
    if (issuePoint) {
      setIssuePoint(issuePoint);
    }
    setTimeout(() => {
      setIssueYardnapha(null);
      setIssuePoint(null);
    }, 4000);
    setStage(null);
  };

  return (
    <>
      {page === PAGES.HOME && (
        <WanderlandHome
          handleBack={() => history.goBack()}
          selectWanderlandId={async (wanderlandId) => {
            if (!config.isMutedSound) {
              selectStage.play();
              await Delay(1000);
            }
            setWanderlandId(wanderlandId);
          }}
        />
      )}
      {page === PAGES.STAGE && (
        <WanderlandStage
          student={student}
          wanderlandId={wanderlandId}
          handleBack={() => setWanderlandId(null)}
          handleStageSelected={async (stage, wanderland) => {
            setWanderland(wanderland);
            setStage(stage);
          }}
          issueYardnapha={issueYardnapha}
          issuePoint={issuePoint}
        />
      )}
      {page === PAGES.STAGE_BOSS && (
        <WanderlandStageBoss
          handleBack={() => {
            setStage(null);
          }}
          stage={stage}
          wanderland={wanderland}
          handleCompleted={() => {
            setStage(null);
          }}
        />
      )}
      {page === PAGES.STAGE_VIDEO && (
        <WanderlandStageVideo
          stage={stage}
          handleBack={handleStageBack}
          handleCompleted={handleStageCompleted}
        />
      )}
    </>
  );
};

const mapStateToProps = ({ student, config }) => ({
  student,
  config,
});

export default connect(mapStateToProps, null)(Wanderland);
